import React from "react";
import { Layout, Menu, Breadcrumb, Divider, Icon } from "antd";
import compose from "lodash/fp/compose";
import gql from "graphql-tag";
import { graphql } from "react-apollo";

import { withSubscribe, LayoutContainer } from "../../state";
import { Link, NavLink, withRouter } from "../../router";

const { Content, Footer, Sider } = Layout;

const meQuery = gql`
  {
    me {
      user {
        id
        username
        isAdmin
        licenseId
      }
    }
  }
`;

const C = ({
  // Breadcrumbs can be set to a list of links, e.g.:
  // [<Link to="/user">Users</Link>, <Link to="/user/foo">User foo</Link>]
  breadcrumbs = [],
  layout,
  location,
  children,
  data: { me: { user } = {}, loading: dataLoading },
}) => (
  <Layout className="c-layout-default">
    <Sider
      collapsible
      collapsed={layout.isCollapsed()}
      onCollapse={layout.collapse}
    >
      <div className="c-layout-default__logo" />
      {(() => {
        if (dataLoading) {
          return null;
        }

        const menu = [];
        menu.push({ title: "Dashboard", to: "/", icon: "pie-chart" });
        if (user.isAdmin) {
          menu.push({ title: "Users", to: "/user", icon: "user" });
          menu.push({ title: "Licenses", to: "/license", icon: "solution" });
        }
        if (user.licenseId || user.isAdmin) {
          menu.push({ title: "Scenarios", to: "/scenario", icon: "edit" });
          menu.push({ title: "Sessions", to: "/session", icon: "rocket" });
        }

        const selectedMenuKeys = [location.pathname];

        return (
          <React.Fragment>
            <Menu
              theme="dark"
              defaultSelectedKeys={selectedMenuKeys}
              selectable={false}
              mode="inline"
              className="c-layout-default__menu"
            >
              {menu.map(({ to, icon, title }) => (
                <Menu.Item key={to}>
                  <NavLink to={to}>
                    <Icon type={icon} />
                    <span>{title}</span>
                  </NavLink>
                </Menu.Item>
              ))}
            </Menu>
            <Divider className="c-layout-default__divider" />
            <Menu
              theme="dark"
              selectable={false}
              mode="inline"
              className="c-layout-default__user-menu"
            >
              <Menu.Item disabled>
                <Link to="/me" disabled>
                  <Icon type="setting" />
                  <span>
                    Hello <em>{user.username}</em>!
                  </span>
                </Link>
              </Menu.Item>
              <Menu.Item>
                <Link to="/logout">
                  <Icon type="logout" />
                  <span>Logout</span>
                </Link>
              </Menu.Item>
            </Menu>
          </React.Fragment>
        );
      })()}
    </Sider>
    <Layout>
      <Content className="c-layout-default__content">
        <Breadcrumb className="c-layout-default__breadcrumb">
          {breadcrumbs.map((item, key) => (
            <Breadcrumb.Item key={key}>{item}</Breadcrumb.Item>
          ))}
        </Breadcrumb>
        <div className="c-layout-default__content__inner">{children}</div>
      </Content>
      <Footer className="c-layout-default__footer">
        TSE ©{new Date().getFullYear()} Created by Thingks
      </Footer>
    </Layout>
  </Layout>
);

const LayoutDefault = compose(
  withRouter,
  withSubscribe({ to: { layout: LayoutContainer } }),
  graphql(meQuery)
)(C);

export default LayoutDefault;
export { meQuery };
